<template>

    <base-modal
        :visible="visible"
        :title="title"
        @close="$emit('close')"
    >

        <div class="py-6 pt-0">
                    
            <form v-if="show_form" class="w-full max-w-lg">
              <div class="flex flex-wrap -mx-3 mb-4">
                <div class="w-full px-3 mb-6 md:mb-0">
                  <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-first-name">
                    Project Name
                  </label>
                  <input autocomplete="off" v-model="projectFormName" class="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:bg-white" type="text" placeholder="Project Name">
                </div>
              </div>

              <div class="flex flex-wrap -mx-3 mb-4">
                <div class="w-full px-3 mb-6 md:mb-0">
                  <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-first-name">
                    Website
                  </label>
                  <input autocomplete="off" v-model="websiteFormName" class="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:bg-white" type="text" placeholder="website.com">
                </div>
              </div>

              <div class="flex flex-wrap -mx-3 mb-6">
                <div class="w-full px-3 mb-6 md:mb-0">
                  <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-first-name">
                    Coin Market Cap Slug
                  </label>
                  <div class="rounded py-2 px-3 bg-gray-200 h-16"><label class="text-pxs font-bold text-gray-700">coinmarketcap.com/</label> <!----> <div data-type="text" class="formulate-input-element formulate-input-element--text"><!----> <input type="text" placeholder="slug" v-model="slugFormName" class="w-full focus:outline-none text-pm text-purple-m-secondary resize-none bg-transparent"> <!----></div> <!----></div>
                </div>
              </div>

              <div class="flex flex-wrap -mx-3 mb-2">
                <div class="w-full px-3 mb-6 md:mb-0">
                  <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-city">
                    Tags
                  </label>

                  <div class="tag-container">
                    <div v-for="activeTag of activeTags" v-bind:key="activeTag.id" class="inline-block p-2 m-1 ml-0 bg-gray-50 rounded-md">
                        <small>{{activeTag.name}}<span class="ml-3 cursor-pointer" v-on:click="removeTag(activeTag)">x</span></small>
                    </div>
                  </div>

                  <input autocomplete="off" v-model="tagText" v-on:keyup.enter="add_new_tag($event.target.value)" v-on:keyup="autoCompleteTags($event.target.value)" class="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:bg-white" id="grid-first-name" type="text" placeholder="Tag">

                  <div v-if="tagMatches.length > 0" class="fixed bg-gray-50 p-1 sm:w-2/4 md:w-1/4">
                      <div v-for="match of tagMatches" v-bind:key="match.id">
                          <div v-on:click="addTag(match)" :id="match.name" class="p-2 cursor-pointer hover:bg-gray-100">{{match.name}}</div>
                      </div>

                  </div>
                </div>
                
              </div>
            </form>

            <div class="text-center" v-if="!show_form">

                <h1>Looks like this entity already exists. Would you like to upvote it?</h1>
                <div class="">
                    <span v-on:click="vote(entity, 'entity')" :class="(entity.voted) ? 'text-green' : ''" class="cursor-pointer">
                        <base-icon class="relative mt-10" :size="20" :name="'voteUp'"></base-icon>
                    </span>
                </div>



            </div>

        </div>

        <!-- Modal footer -->
        <div v-if="show_form" class="flex items-center p-6 space-x-2 rounded-b border-t border-gray-200 dark:border-gray-600">
            <button v-on:click="saveProject" data-modal-toggle="defaultModal" type="button" class="text-black bg-green-400 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
            <button v-on:click="$emit('close')" data-modal-toggle="defaultModal" type="button" class="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:ring-gray-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600">Close</button>
        </div>

    </base-modal>
</template>

<script>

import BaseIcon from '../components/BaseIcon';

export default {
    props: ['visible', 'tags'],
    components: {
        BaseIcon
    },
    computed: {
        title () {
            return "Add Project";
        }
    },
    data() {
        return {
            projectFormName: "",
            rojectFormName: "",
            websiteFormName: "",
            slugFormName: "",
            tagText: "",
            tagMatches: [],
            activeTags: [],
            show_form: true,
            entity: {}
        }
    },
    watch: {
    },
    mounted () {
        this.clearForm();
    },
    methods: {

        async vote(object) {
            console.log(object);
            var post_data = {
                "object_id": object.id,
                "user_id": this.$store.getters.me.id,
                "type_id": 21
            };

            const { data } = await this.$http.post(`/users/vote/new`, post_data);

            if ( object.status == 0 ) {
                const { data } = await this.$http.post(`/entities/undelete`, {entity_id: object.id});
            }

            this.$emit('reloadEntites');
            this.$emit('close');
            this.clearForm();

        },

        async submitForm() {
            this.submitting = true;
            
        },
        
        clearForm() {
            this.projectFormName = "";
            this.rojectFormName = "";
            this.websiteFormName = "";
            this.slugFormName = "";
            this.tagText = "";
            this.tagMatches = [];
            this.activeTags = [];
            this.show_form = true;
            
        },

        add_new_tag(value) {

            //const regexp = new RegExp(value, 'i');
            var matches = this.activeTags.filter(x => x.name.toLowerCase().includes(value.toLowerCase()));

            if ( matches.length == 0 ) {
                this.activeTags.push({'name': value, 'id': null});
                this.tagMatches = [];
                this.tagText = "";                
            }

        },

        autoCompleteTags(value) {
            
            if ( value.length > 2 ) {
                //const regexp = new RegExp(value, 'i');
                this.tagMatches = this.tags.filter(x => x.name.toLowerCase().includes(value.toLowerCase()));
            } else {
                this.tagMatches = [];
            }

        },

        addTag(tag) {

            this.activeTags.push(tag);
            this.tagMatches = [];
            this.tagText = "";

        },

        async saveProject() {

            var post_data = {
                "name": this.projectFormName,
                "tags": this.activeTags,
                "website": this.websiteFormName,
                "cmc_slug": this.slugFormName
            };

            const { data } = await this.$http.post(`/entities/entity/new`, post_data);
        
            if (!data.exists) {
                this.$emit('reloadEntites');
                this.$emit('close');
                this.clearForm();
            } else if (data.exists) {
                this.entity = data.entity;
                this.clearForm();
                this.show_form = false;

            }

            this.mixpanel.track("Saved a New Project", post_data);

        },

        removeTag(tag) {
            console.log(tag);
            var new_arr = [];
            for ( var active_tag of this.activeTags ) {
                if ( active_tag.name != tag.name ) {
                    new_arr.push(active_tag);
                }
            }

            console.log(new_arr);
            this.activeTags = new_arr;

        },
    }
}
</script>